/**
 * ============================================================================
 * BAMBOOVE — "YOU MAY ALSO LIKE" (sát chân trang PDP) · phiên 76 · 17/10/2026
 * ----------------------------------------------------------------------------
 * PHƯƠNG ÁN ĐÃ CHỐT (phiên 75k — tin #814 trình, #815 anh duyệt):
 *   • MÁY TÍNH   : 1 HÀNG 12 thẻ — KÉO bằng chuột + 2 MŨI TÊN ‹ › (1 bước = 1 thẻ)
 *   • ĐIỆN THOẠI : 2 hàng carousel — CSS lo (thẻ 60vw = "1 ảnh + ló ảnh 2");
 *                  kéo/vuốt + hút snap do `bamboove-bestsellers.js` lo
 *                  (2 track có `data-bs-grid` — không viết lại).
 *   • TRỘN       : mỗi lần tải trang, trộn NGẪU NHIÊN TRONG TỪNG NHÓM CON
 *                  (`data-goiy-ut`: 1 = cùng dòng · 2 = cùng loại khác dòng ·
 *                  3 = loại khác hẳn) — ranh giới nhóm GIỮ NGUYÊN nên món
 *                  LIÊN QUAN luôn đứng trước món ít liên quan.
 * Đây là file JS RIÊNG của khối này — KHÔNG đụng file nào khác của theme.
 * ============================================================================
 */
(function () {
  'use strict';

  /* ---------------------- 1) TRỘN TRONG TỪNG NHÓM CON ---------------------- */
  function tronMang(mang) {
    for (var i = mang.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = mang[i]; mang[i] = mang[j]; mang[j] = t;
    }
  }

  function tron() {
    document.querySelectorAll('[data-goiy-track]').forEach(function (track) {
      if (track.getAttribute('data-goiy-da-tron')) return;  /* trình soạn vẽ lại: mỗi bản vẽ trộn 1 lần */
      track.setAttribute('data-goiy-da-tron', '1');
      var con = Array.prototype.slice.call(track.children);
      var i = 0;
      while (i < con.length) {
        var j = i + 1;
        var ut = con[i].getAttribute ? con[i].getAttribute('data-goiy-ut') : null;
        while (j < con.length && con[j].getAttribute('data-goiy-ut') === ut) j++;
        var nhom = con.slice(i, j);
        if (nhom.length > 1) {
          tronMang(nhom);
          /* thứ tự NHÓM không đổi — chỉ đổi thứ tự trong nhóm */
          nhom.forEach(function (el) { track.appendChild(el); });
        }
        i = j;
      }
    });
  }

  /* ----------------- 2) MŨI TÊN + 3) KÉO CHUỘT (máy tính) ----------------- */
  function buocThe(khu) {
    var the = khu.querySelector('.product-card');
    return the ? Math.round(the.getBoundingClientRect().width + 16)
               : Math.round(khu.clientWidth * 0.8);
  }

  function ganKhu(khu) {
    if (khu.getAttribute('data-goiy-gan')) return;
    khu.setAttribute('data-goiy-gan', '1');

    /* cấm trình duyệt kéo-thả link/ảnh — không thì cú kéo bằng chuột bị CẮT giữa đường */
    khu.querySelectorAll('a, img').forEach(function (el) { el.setAttribute('draggable', 'false'); });

    var khoi = khu.closest('.bamboove-bs--goiy');
    var nutLui = khoi ? khoi.querySelector('[data-goiy-lui]') : null;
    var nutToi = khoi ? khoi.querySelector('[data-goiy-toi]') : null;

    function capNhatNut() {
      if (!nutLui || !nutToi) return;
      var toiDa = Math.max(0, khu.scrollWidth - khu.clientWidth);
      nutLui.disabled = khu.scrollLeft <= 2;
      nutToi.disabled = khu.scrollLeft >= toiDa - 2;
    }

    if (nutLui) nutLui.addEventListener('click', function () {
      khu.scrollBy({ left: -buocThe(khu), behavior: 'smooth' });
    });
    if (nutToi) nutToi.addEventListener('click', function () {
      khu.scrollBy({ left: buocThe(khu), behavior: 'smooth' });
    });
    khu.addEventListener('scroll', capNhatNut, { passive: true });
    window.addEventListener('resize', capNhatNut);

    var dangKeo = false, x0 = 0, sl0 = 0, daDi = 0;

    /* ⚠️ BÀI HỌC (phiên 76 d): TUYỆT ĐỐI KHÔNG `setPointerCapture` ở đây — capture làm cú
       BẤM vào ẢNH/TÊN thẻ bị “nuốt”: sự kiện `click` bị chuyển LÊN khung kéo thay vì vào
       thẻ <a> ⇒ khách bấm thẻ KHÔNG sang trang sản phẩm (chỉ có nút cỡ hoạt động).
       Nay theo dõi kéo bằng listener trên `window` — vẫn kéo thoải mái (ra ngoài khung cũng theo). */
    khu.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;                          /* ngón tay: NHƯỜNG trình duyệt */
      if (!window.matchMedia('(min-width:750px)').matches) return;    /* khổ hẹp: để track tự lo */
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest && e.target.closest('.card-quickadd, .size-picker')) return;
      if (khu.scrollWidth <= khu.clientWidth + 2) return;
      dangKeo = true; daDi = 0;
      x0 = e.clientX; sl0 = khu.scrollLeft;
      khu.classList.add('is-keo');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dangKeo) return;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > daDi) daDi = Math.abs(dx);
      khu.scrollLeft = sl0 - dx;                                      /* bám 1:1 theo con trỏ */
      if (daDi > 6) e.preventDefault();
    });
    function ketThuc() {
      if (!dangKeo) return;
      dangKeo = false;
      khu.classList.remove('is-keo');
    }
    window.addEventListener('pointerup', ketThuc);
    window.addEventListener('pointercancel', ketThuc);

    /* kéo > 6px ⇒ CHẶN cú bấm (không mở nhầm trang sản phẩm) */
    khu.addEventListener('click', function (e) {
      if (daDi > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    capNhatNut();
  }

  function chay() {
    tron();
    document.querySelectorAll('[data-goiy-khu]').forEach(ganKhu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chay);
  } else {
    chay();
  }
  /* trình soạn theme vẽ lại section ⇒ gắn lại */
  document.addEventListener('shopify:section:load', chay);
})();
